import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import SimpleCollection from '../Organisms/SimpleCollection/';
import Typography from '@material-ui/core/Typography';

import Message from '../Atoms/Message';
import MessageInput from './Chat/MessageInput';

export interface IChannelViewProps extends RouteComponentProps {
    messages: any[];
    channel_name: string;
    sendMessageAsAlertUser: Function;
    toggleBlockChannelMessage: Function;
    fetchUserAvatar: Function;
}

const ChannelView = (props: IChannelViewProps) => {
    const { messages, toggleBlockChannelMessage } = props;

    const handleCreateMessage = (text: any) => {
        props.sendMessageAsAlertUser(text);
        return true;
    };

    return (
        <React.Fragment>
            <Grid data-cy="channels-message-view" item md={6} xs={12}>
                <Typography component="h2" gutterBottom={true} variant="h5">
                    Messages
                </Typography>
                <SimpleCollection
                    data={messages}
                    height="50vh"
                    itemRender={message => (
                        <Message
                            blockedStatusField="isBlockedByAdmin"
                            data={message}
                            fetchUserAvatar={props.fetchUserAvatar}
                            flagged="flagged"
                            name="senderName"
                            options={[]}
                            text="text"
                            timestamp="timestamp"
                            toggleBlock={toggleBlockChannelMessage}
                            userId="senderId"
                        />
                    )}
                    mode="dark"
                    reorderable={false}
                    stickToBottom={true}
                    type="list"
                />
                <MessageInput disabled={messages.length === 0} handleCreateMessage={handleCreateMessage} />
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(ChannelView);
